import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';


import './Css/Payment.css';
import CompanyInfoChip from "../Components/CompanyInfoChip";
import icon_search from "../Image/icon_search.png";
import refreshbtn from "../Image/refresh-btn.png";
import deletebtn from "../Image/deletebtn.png";
import retouch from "../Image/retouch.png";
import html2canvas from "html2canvas";
import Bill from "../Components/Bill"
import ExitProcessingModal from "../Components/ExitProcessingModal";
import EditModal from "../Components/EditModal";
import config from "../ip.json";
import axios from "axios";
import CompanyCardListinRoomNumber from "../Components/CompanyCardListinRoomNumber";
import Swal from "sweetalert2";
import {toCommaedNumber} from "../DataBind/common";
import SeeAllModal from "../Components/SeeAllModal";


const captureToImage = (elementId) => {
    return new Promise((resolve, reject) => {
        const element = document.getElementById(elementId);
        if (!element) {
            reject('Element not found');
            return;
        }

        html2canvas(element)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                resolve(imgData);
            })
            .catch((error) => reject(error));
    });
};

const Payment = () => {

    const [companyData, setCompanyData] = useState({
        company: '기업을 선택해 주세요.',
        boss: '-',
        phone: '-',
        certificate_registration: '-',
        rooms: [],
        roomCount: '-',
        deposit: 0,
        // total_amount: 0,
        // depositByRoom: [],
        // entryDate: '-',
        // isCorporate: false

    });
    const [rooms, setRooms] = useState([]);
    const [isChecked, setIsChecked] = useState(true);  // 선택된 방 저장 상태
    const [isDateChecked, setIsDateChecked] = useState(false);  // 선택된 방 저장 상태
    const [selectedYear, setSelectedYear] = useState(''); // 선택된 값을 저장
    const [selectedDay, setSelectedDay] = useState(''); // 선택된 값을 저장
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({length: currentYear - 2000}, (_, i) => 2001 + i);
    const [searchValue, setSearchValue] = useState(""); // 검색어 상태

    const now = new Date(); // 현재 날짜와 시간을 가져옴

    const nowYear = now.getFullYear(); // 현재 연도
    const nowMonth = now.getMonth() + 1; // 현재 월 (0부터 시작하므로 +1 필요)
    const nowDay = now.getDay(); // 현재 월 (0부터 시작하므로 +1 필요)


    const navigate = useNavigate();
    const [isExitModalOpen, setExitIsModalOpen] = useState(false); // 모달의 상태를 관리
    const [isEditModalOpen, setEditIsModalOpen] = useState(false); // 모달의 상태를 관리
    const [testArr, setTestArr] = useState([]); // 모달의 상태를 관리
    const companyNames = testArr.map(item => item);
    const [dataListArr, setDataListArr] = useState([]); // 모달의 상태를 관리
    const [loding, setLoding] = useState(true); // 로딩 상태
    const dataList = dataListArr.map(item => item);


    const [totalRent, setTotalRent] = useState(0); // 총 임대료
    const [totalElectric, setTotalElectric] = useState(0); // 총 전기료
    const [totalGas, setTotalGas] = useState(0); // 총 가스비
    const [totalSurtax, setTotalSurtax] = useState(0); // 총 부가세
    const [total, setTotal] = useState(0); // 최종 합계


    const [rent, setRent] = useState(''); // 임대료
    const [surtax, setSurtax] = useState(''); // 부가세
    const [electricity, setElectricity] = useState(''); // 전기세
    const [gas, setGas] = useState(''); // 가스비

    const [selectRoomNumber, setSelectRoomNumber] = useState(''); // 선택된 값 저장
    const handleSelectChange = (event) => {
        setSelectRoomNumber(event.target.value); // 선택된 값 업데이트
    };


    useEffect(() => {
        calculateTotal()
    }, [dataList]);


    useEffect(() => {
        const room999 = dataList
            .slice() // 원본 데이터 보호 (dataList를 복사)
            .sort((a, b) => new Date(b.create_time) - new Date(a.create_time)) // 내림차순 정렬
            .find(item => item.room_number === selectRoomNumber); // selectRoomNumber와 일치하는 방 찾기

        if (room999) {
            setRent(room999.rent);
            setSurtax(room999.surtax);
        } else {
            // room999가 없을 경우 처리할 로직 (예: 기본값 설정 등)
            setRent(""); // 기본값 설정 예시
            setSurtax(""); // 기본값 설정 예시
        }

    }, [companyData.company, selectRoomNumber]); // dataList와 selectRoomNumber가 변경될 때마다 실행


    useEffect(() => {
        if (companyData) {
            setDataListArr([]); // 데이터 배열을 상태로 설정


            getList(companyData.company); // companyData.company가 변경될 때마다 실행
            calculateTotal()
        }
    }, [companyData]); // companyData가 변경될 때마다 실행


    useEffect(() => {
        setLoding(true)
        fetchData(); // 비동기 함수 호출
    }, []); // companyData.company를 의존성으로 설정


    const fetchData = async () => {
        try {
            const response = await axios.get(config.url + "/v2/company/all", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true, // 쿠키 필요 시 설정
            });
            console.log(response.data); // 콘솔로 데이터 확인
            setTestArr(response.data); // 데이터 배열을 상태로 설정
            setLoding(false)


        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }
        console.log("페치데이타 실행됨");
    };

    const 새로고침완료 = () => {
        Swal.fire({
            title: "새로고침 완료",
            icon: "success"
        });
    };

    const 새로고침실패 = (text) => {
        Swal.fire({
            title: text.toString(),
            icon: "error"
        });
    };

    const 내역추가완료 = () => {
        Swal.fire({
            title: "내역을 추가하였습니다!",
            icon: "success"
        });
    };

    const 내역추가실패 = () => {
        Swal.fire({
            title: "내역을 추가에 실패하였습니다!",
            icon: "error"
        });
    };

    const getList = async (companyName) => {
        const jwtToken = sessionStorage.getItem("Authorization");

        try {
            const response = await axios.get(config.url + "/v2/payment/company/not_paid", {
                params: {
                    name: companyName,
                },
                headers: {
                    Authorization: jwtToken,
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });

            // 데이터가 배열인지 확인
            if (Array.isArray(response.data)) {
                setDataListArr(response.data); // 배열 그대로 사용
            } else {
                console.warn("Response data is not an array, converting it.");
                setDataListArr([response.data]); // 객체를 배열로 감싸기
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }

    };

    const refresh = () => {
        setDataListArr([]); // 데이터 배열을 상태로 설정

        getList(companyData.company); // companyData.company가 변경될 때마다 실행
        calculateTotal()
        새로고침완료()


    }

    const calculateTotal = () => {


        // 초기 값 설정
        let rentSum = 0;
        let electricSum = 0;
        let gasSum = 0;
        let surtaxSum = 0;
        let totalSum = 0;

        // dataList 순회하며 계산
        dataList.forEach((item) => {
            if (item.res_rent === null) {
                rentSum += item.rent || 0; // rent 값이 없으면 0 처리
            }
            if (item.res_elec === null) {
                electricSum += item.elec_bill || 0; // elec_bill 값이 없으면 0 처리
            }
            if (item.res_gas === null) {
                gasSum += item.gas_bill || 0; // gas_bill 값이 없으면 0 처리
            }
            if (item.res_surtax === null) {
                surtaxSum += item.surtax || 0; // surtax 값이 없으면 0 처리
            }
        });

        // 총합 계산
        totalSum = rentSum + electricSum + gasSum + surtaxSum;

        // 상태 업데이트
        setTotalRent(rentSum);
        setTotalElectric(electricSum);
        setTotalGas(gasSum);
        setTotalSurtax(surtaxSum);
        setTotal(totalSum);

        // 결과 출력
        // console.log("Total Rent:", rentSum);
        // console.log("Total Electric:", electricSum);
        // console.log("Total Gas:", gasSum);
        // console.log("Total Surtax:", surtaxSum);
        // console.log("Grand Total:", totalSum);
    };

    const handleSave = (updatedData) => {
        // console.log("수정된 데이터:", updatedData);
    };
    const openExitModal = () => {
        setExitIsModalOpen(true); // 모달 열기
    };
    const closeExitModal = async () => {
        setExitIsModalOpen(false); // 모달 닫기
        try {
            const response = await axios.get(config.url + "/v2/company/search3", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true, // 쿠키 필요 시 설정
                params: {
                    name: companyData.company, // 쿼리 파라미터로 데이터 전달
                },
            });

            for (let i = 0; i < testArr.length; i++) {
                if (testArr[i].company === response.data.company) {
                    // console.log(i+"번째 입니다. "+testArr[i].company+"그리고"+response.data.company);

                    setTestArr(prevTestArr =>
                        prevTestArr.map((item, index) =>
                            index === i ? response.data : item // 해당 인덱스만 변경
                        )
                    );
                    break

                }

            }

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }
    };
    const openEditModal = () => {
        setEditIsModalOpen(true); // 모달 열기
    };

    const closeEditModal = async () => {
        setEditIsModalOpen(false); // 모달 닫기
        try {
            const response = await axios.get(config.url + "/v2/company/search3", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true, // 쿠키 필요 시 설정
                params: {
                    name: companyData.company, // 쿼리 파라미터로 데이터 전달
                },
            });

            for (let i = 0; i < testArr.length; i++) {
                if (testArr[i].company === response.data.company) {
                    // console.log(i+"번째 입니다. "+testArr[i].company+"그리고"+response.data.company);

                    setTestArr(prevTestArr =>
                        prevTestArr.map((item, index) =>
                            index === i ? response.data : item // 해당 인덱스만 변경
                        )
                    );
                    break

                }

            }

        } catch (error) {
            console.error("Error fetching data:", error);
            alert("데이터를 가져오는 중 문제가 발생했습니다.");
        }

    };


    useEffect(() => {

        if (testArr.length > 0) {
            const value = testArr.findIndex(item => item.company === companyData.company);
            if (value !== -1) {
                const index = testArr.findIndex(item => item.company === testArr[value].company);
                let testrooms = testArr[index].rooms;
                setRooms(testrooms);

                setCompanyData({
                    total_amount: testArr[index].total_amount,
                    id: testArr[index].id,
                    company: testArr[index].company,
                    boss: testArr[index].boss,
                    phone: testArr[index].phone,
                    certificate_registration: testArr[index].certificate_registration,
                    rooms: [...testrooms],
                    roomCount: testArr[index].roomCount,
                    deposit: testArr[index].deposit,
                    depositByRoom: testArr[index].depositByRoom,
                    entryDate: testArr[index].regDate,
                    isCorporate: testArr[index].is_corp,
                });

            }
        }
    }, [testArr]);  // testArr 상태가 변경될 때마다 실행됨

    const handleChangeSelectedYear = (event) => {
        setSelectedYear(event.target.value); // 선택 값 업데이트
    };
    const handleChangeSelectedDay = (event) => {
        setSelectedDay(event.target.value); // 선택 값 업데이트
    };

    const handleToggle = () => {
        setIsChecked(!isChecked);
        setIsDateChecked(!isDateChecked);
    };
    const handleDateToggle = () => {
        setIsDateChecked(!isDateChecked);
        setIsChecked(!isChecked);

    };

    const [showModal, setShowModal] = useState(false); // 모달 열기/닫기 상태

    const handleViewAll = () => {
        setShowModal(true); // 모달 열기
    };

    const handleCloseModal = () => {
        setShowModal(false); // 모달 닫기
    };

    const handleChipClick = (name) => {
        setRent('')
        setSurtax('')
        setGas('')
        setElectricity('')
        setSelectRoomNumber('');
        setCompanyData([])

        const index = testArr.findIndex(item => item.company === name);
        let testarr = testArr[index].rooms;
        setRooms(testArr[index].rooms);


        setCompanyData({
            total_amount: testArr[index].total_amount,
            id: testArr[index].id,
            company: testArr[index].company,
            boss: testArr[index].boss,
            phone: testArr[index].phone,
            certificate_registration: testArr[index].certificate_registration,
            rooms: testarr, // 배열 자체를 복사하여 추가
            roomCount: testArr[index].roomCount,
            deposit: testArr[index].deposit,
            depositByRoom: testArr[index].depositByRoom,
            entryDate: testArr[index].regDate,
            isCorporate: testArr[index].is_corp,
        });


    };


    const addList = async () => {
        setSelectedDay('')
        setSelectedYear('')
        let year = ''
        let month = ''

        if (isDateChecked == true) {


            year = selectedYear;
            month = selectedDay;

        } else {


            year = nowYear;
            month = nowMonth;

        }


        if (year == '' || month == '') {
            alert("날짜를 선택해 주세요")
        } else {
            const formattedYear = String(year).padStart(2, '0');
            const formattedMonth = String(month).padStart(2, '0');


            if (rent === '' || surtax === '' || electricity === '' || gas === '') {
                alert("값을 제대로 입력해주세요.")
            } else {


                const jwtToken = sessionStorage.getItem("Authorization");

                try {
                    const response = await axios.post(config.url + "/v2/payment/add",
                        {

                            company: String(companyData.company),
                            room_room_number: String(selectRoomNumber),
                            now_date: formattedYear + "-" + formattedMonth + "-01",
                            // now_date: "2024-12-20",
                            rent: rent,
                            surtax: surtax,
                            elec_bill: electricity,
                            gas_bill: gas,
                            res_surtax: null,
                            res_elec: null,
                            res_gas: null,
                            res_rent: null,
                        },
                        {
                            headers: {
                                Authorization: jwtToken,

                                "Content-Type": "application/json",
                            },
                            withCredentials: true, // 쿠키 필요 시 설정
                        });


                    // console.log(response.data); // 콘솔로 데이터 확인
                    내역추가완료()

                } catch (error) {
                    console.error("Error fetching data:", error);
                    alert("데이터를 가져오는 중 문제가 발생했습니다.");
                    내역추가실패()
                }
                setDataListArr([]); // 데이터 배열을 상태로 설정


                getList(companyData.company); // companyData.company가 변경될 때마다 실행
                calculateTotal()


            }


        }


    }
    const moveToPrint = () => {
        navigate('/Print');
    }
    const rightHandleSpecificChipClick = () => {
        let name = '';

        for (let i = 0; i < companyNames.length; i++) {
            if (companyNames[i].company === companyData.company) {
                // 배열 범위 초과 방지
                if (i + 1 < companyNames.length) {
                    name = companyNames[i + 1].company;
                    handleChipClick(name); // id가 3인 버튼의 동작 실행


                } else {
                    console.log("마지막 요소입니다. 다음 항목이 없습니다.");
                }
            }
        }

    };

    const LeftHandleSpecificChipClick = () => {
        let name = '';

        for (let i = 0; i < companyNames.length; i++) {
            if (companyNames[i].company === companyData.company) {
                // 배열 범위 초과 및 언더플로우 방지
                if (i - 1 >= 0) {
                    name = companyNames[i - 1].company;
                    handleChipClick(name); // id가 3인 버튼의 동작 실행

                } else {
                    console.log("첫 번째 요소입니다. 이전 항목이 없습니다.");
                }
            }
        }
    };

    // 검색 필터링 로직
    const filteredCompanies = companyNames.filter((item) =>
        item.company.toLowerCase().includes(searchValue.toLowerCase()) // 대소문자 구분 없음
    );

    // 검색어 변경 핸들러
    const handleSearchChange = (event) => {
        setSearchValue(event.target.value); // 검색어 업데이트
    };

    return (
        <div className="registration-container">

            <div className="registration-middle-container">
                <div className="registration-sidebar">
                    <div className="search">
                        <img className="icon_search" src={icon_search} alt="See more"/>
                        <input
                            className="search-bar"
                            placeholder="업체명을 입력하세요"
                            value={searchValue} // 입력값과 상태 연동
                            onChange={handleSearchChange} // 검색어 입력 시 업데이트
                        />
                    </div>

                    {loding ? (
                        <div className="sidebar-loader"></div> // 로딩 스피너 출력
                    ) : (
                        filteredCompanies.map((item) => (
                            <CompanyInfoChip
                                key={item.id}
                                name={item.company}
                                roomCount={item.roomCount}
                                onClick={handleChipClick} // ID 전달
                            />
                        ))
                    )}
                </div>

                {/* 메인 박스 */}
                <div className="payment-mainbox">
                    <div className={"payment-mainbox-left"}>
                        <div className={'payment-company-titlebox'}>
                            <img className="retouch-company-btn" src={retouch}
                                 alt="See more" onClick={openEditModal}/>
                            <EditModal
                                isOpen={isEditModalOpen}
                                closeModal={() => closeEditModal()}
                                companyName={companyData.company}
                                businessNumber={companyData.certificate_registration}
                                representative={companyData.boss}
                                phoneNumber={companyData.phone}
                                room={rooms}
                                entryDate={companyData.entryDate}
                                deposit={companyData.deposit}
                                depositByRoom={companyData.depositByRoom}
                                isCorporate={companyData.isCorporate}
                                onSave={handleSave}
                            />


                            <div className={"payment-company-name"}>{companyData.company}
                                <img className="delete-company-btn" src={deletebtn} alt="See more"
                                     onClick={openExitModal}/>
                                <ExitProcessingModal
                                    isOpen={isExitModalOpen}
                                    closeModal={closeExitModal}
                                    companyName={companyData.company}
                                    roomArray={companyData.rooms}
                                />

                            </div>
                            <div className={"payment-company-info-box"}>
                                <div className={'payment-company-info-innerbox'}>
                                    <div className={'payment-info-cap'}>대표자 : {companyData.boss}</div>
                                    <div className={'payment-info-use-room'}> 입주
                                        호실: {companyData.rooms.map((room) => `${room}호`).join(', ')}
                                    </div>
                                </div>
                                <div className={'payment-info-box'}>
                                    <div className={'payment-info'}> 보증금:
                                        ₩ {new Intl.NumberFormat('ko-KR').format(companyData.deposit)}
                                    </div>
                                    <div className={'payment-info-1'}>사업자번호
                                        : {companyData.certificate_registration}</div>
                                    <div className={'payment-info-1'}>전화번호 : {companyData.phone}</div>

                                </div>

                            </div>


                        </div>
                        <div className={'payment-add'}>
                            <div className={'line'}></div>
                            <div className={'room-select-box'}>
                                <div className={'room-select-box-text'}>호실 선택</div>
                                <select
                                    className="room-select-box-dropbar"
                                    value={selectRoomNumber} // 선택된 값 반영
                                    onChange={handleSelectChange} // 값 변경 핸들러 연결
                                >
                                    <option value="" disabled>호실</option>
                                    {companyData.rooms.map((room, index) => (
                                        <option key={index} value={room}>{room}</option>
                                    ))}
                                </select>

                            </div>

                            <div className={'payment-add-1-box-container'}>

                                <div>
                                    <div className={'payment-add-1-box'}>
                                        <div className="toggle-container">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                id="toggle1" // 첫 번째 토글의 ID 수정
                                                checked={isChecked}
                                                onChange={handleToggle}
                                            />
                                            <label className="switch" htmlFor="toggle1">
                                                <span className="slider"></span>
                                            </label>
                                        </div>
                                        {/*<text>내역 추가일 기준 년/월로 지정</text>*/}
                                        <div
                                            className={'test-bax'}
                                            style={{
                                                color: isChecked ? 'black' : '#C5C5C5',
                                            }}
                                        >
                                            내역 추가일 기준 년/월로 지정
                                        </div>

                                    </div>


                                    <div className={'payment-add-1-box'}>
                                        <div className="toggle-container">
                                            <input
                                                type="checkbox"
                                                className="checkbox"
                                                id="toggle2" // 두 번째 토글의 ID 수정
                                                checked={isDateChecked}
                                                onChange={handleDateToggle}
                                            />
                                            <label className="switch" htmlFor="toggle2">
                                                <span className="slider"></span>
                                            </label>
                                        </div>

                                        <div className="dropdown-box">
                                            <div
                                                className="my-text"
                                                style={{
                                                    color: isDateChecked ? 'black' : '#C5C5C5',
                                                }}
                                            >
                                                직접 지정
                                            </div>
                                            <select
                                                id="dropdown-year"
                                                className="dropdown dropdown-year"
                                                value={selectedYear}
                                                onChange={handleChangeSelectedYear}
                                                style={{
                                                    color: isDateChecked ? 'black' : '#C5C5C5',
                                                    border: isDateChecked ? '1px solid black' : '1px solid #C5C5C5',
                                                }}
                                                disabled={!isDateChecked} // isDateChecked가 false일 때 비활성화
                                            >
                                                <option value="" disabled>
                                                    년
                                                </option>
                                                {yearOptions.map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                id="dropdown-day"
                                                className="dropdown dropdown-day"
                                                value={selectedDay}
                                                onChange={handleChangeSelectedDay}
                                                style={{
                                                    color: isDateChecked ? 'black' : '#C5C5C5',
                                                    border: isDateChecked ? '1px solid black' : '1px solid #C5C5C5', // 기본값 지정
                                                }}
                                                disabled={!isDateChecked}  // isDateChecked가 false일 때 비활성화

                                            >
                                                <option value="" disabled>월</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className={'line'}></div>
                                </div>
                                <div className="box">
                                    <div className="group">
                                        <div className="text-wrapper">
                                            {isDateChecked
                                                ? `${selectedYear}년 ${selectedDay}월 추가 예정`
                                                : `${nowYear}년 ${nowMonth}월 추가 예정`}
                                        </div>
                                        <button className="box-button" onClick={addList}>
                                            <div className="label">내역 추가 +</div>

                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div className={'payment-add-2'}>
                                <div className={'add-input-component'}>
                                    <div className={'add-input-component-title'}>임대료</div>
                                    {/*<label className="container">*/}
                                    {/*    <input type="checkbox"/>*/}
                                    {/*    <div className="checkmark"></div>*/}
                                    {/*</label>*/}
                                    {/*<div className={'remember'}> 기억하기</div>*/}
                                    <div className="input-pay">
                                        <input
                                            type="text"
                                            placeholder="예) 2,000,000"
                                            value={rent}
                                            onChange={(e) => setRent(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className={'add-input-component'}>
                                    <div className={'add-input-component-title'}>부가세</div>
                                    {/*<label className="container">*/}
                                    {/*    <input type="checkbox"/>*/}
                                    {/*    <div className="checkmark"></div>*/}
                                    {/*</label>*/}
                                    {/*<div className={'remember'}> 기억하기</div>*/}
                                    <div className="input-pay">
                                        <input
                                            type="text"
                                            placeholder="예) 2,000,000"
                                            value={surtax}
                                            onChange={(e) => setSurtax(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className={'add-input-component'}>
                                    <div className={'add-input-component-title'}>전기세</div>
                                    <div className="input-pay">
                                        <input
                                            type="text"
                                            placeholder="예) 2,000,000"
                                            value={electricity}
                                            onChange={(e) => setElectricity(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className={'add-input-component'}>
                                    <div className={'add-input-component-title'}>가스비</div>
                                    <div className="input-pay">
                                        <input
                                            type="text"
                                            placeholder="예) 2,000,000"
                                            value={gas}
                                            onChange={(e) => setGas(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className={'refresh-btn-box'}>
                            <div className={'non-pay'}>미납내역</div>
                            <img className="refresh-btn" src={refreshbtn} alt="See more"
                                 onClick={refresh}/>

                        </div>


                        <div className={'payment-view'}>
                            <div className={"Payment-paytitle-box"}>
                                <div className={'pay'}>년월</div>
                                <div className={'pay'}>임대료</div>
                                <div className={'pay'}>부가세</div>
                                <div className={'pay'}>전기세</div>
                                <div className={'pay'}>도시가스</div>
                                <div className={'pay'}>총 미납액</div>
                                <div className={'pay-o'}></div>
                            </div>
                            <div className={'payment-scroll'}>
                                {dataList
                                    .slice() // 원본 데이터 보호 (dataList를 복사)
                                    .sort((a, b) => new Date(b.create_time) - new Date(a.create_time)) // 내림차순 정렬
                                    .map((room, index) => (
                                        <CompanyCardListinRoomNumber
                                            key={room.id} // 유니크한 key 추가
                                            id={room.id}
                                            years={room.create_time}
                                            surtax={room.surtax}
                                            rental={room.rent}
                                            electricityBill={room.elec_bill}
                                            gasBill={room.gas_bill}
                                            isRental={room.res_rent}
                                            isElectricityBill={room.res_elec}
                                            isGasBill={room.res_gas}
                                            isSurtax={room.res_surtax}
                                            room_number={room.room_number}
                                            total_amount={room.total_amount}
                                            deleteRecordFunction={refresh}
                                        />
                                    ))}
                            </div>
                            <div className={"Payment-under-box"}>
                                <div className={'show-pay1'}>
                                    <div className={'show-pay1-text1'}>
                                        <a>임대료</a>
                                        <b> : {toCommaedNumber(totalRent)} /&nbsp;</b>
                                        <a>부가세</a>
                                        <b> : {toCommaedNumber(totalSurtax)} </b>

                                    </div>
                                    <div className={'show-pay1-text2'}>
                                        <a>전기세</a>
                                        <b> : {toCommaedNumber(totalElectric)} /&nbsp;</b>

                                        <a>가스요금</a>
                                        <b> : {toCommaedNumber(totalGas)}</b>
                                    </div>
                                </div>
                                <div className={'show-pay2'}>
                                    합계 : {toCommaedNumber(total)}원
                                </div>

                            </div>


                        </div>
                        <div className={'view-all'} onClick={handleViewAll}>
                            전체 내역 보기

                        </div>
                        {/* SeeAllModal 컴포넌트 */}
                        <SeeAllModal
                            show={showModal}
                            companyData={companyData}
                            onClose={handleCloseModal}
                        />


                    </div>
                    <div className={"payment-mainbox-right"}>
                        <div className={'gosiseo-info'}>고지서에 들어갈 내용</div>
                        <div className={'bill-box'}>

                            <Bill companyName={companyData.company} total_amount={total} rooms={companyData.rooms}
                                  deposit={companyData.deposit} dataList={dataList}/>
                        </div>

                        <div className={'gojiseo-btn-box'}>
                            <div className={'view-gojiseo-btn'} onClick={LeftHandleSpecificChipClick}>
                                이전 기업
                            </div>
                            <div className={'view-gojiseo-btn2'} onClick={moveToPrint}>
                                고지서 출력
                            </div>
                            <div className={'view-gojiseo-btn'} onClick={rightHandleSpecificChipClick}>
                                다음 기업
                            </div>
                        </div>


                    </div>


                </div>

            </div>
        </div>
    );
};

export default Payment;




